/* funnls - Aura product page. Additive; loads only where funnls-pdp-head is
   rendered. Guarded so the theme editor's section reloads cannot bind twice.

   Three jobs, none of them price arithmetic:
   1. Buttons marked data-flp-atc delegate to the buy box's real add-to-cart
      button, so the existing product form (and everything wired to it) does
      the work. Without JS they are plain links to the buy box.
   2. The offer price is mirrored from [data-sticky-price-source] into any
      [data-flp-price-mirror], so one block owns the number.
   3. Video progress and the post-video add-to-cart are announced as
      `funnls:video` DOM events (and to window.dataLayer if one ever exists). */
(function () {
  if (window.__flpPdpInit) return;
  window.__flpPdpInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mainAtcButton() {
    return (
      document.querySelector('product-form-component form button[type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]')
    );
  }

  function emit(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent('funnls:video', { detail: Object.assign({ action: name }, detail || {}) }));
    } catch (e) {}
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'funnls_video_' + name }, detail || {}));
    }
  }

  /* 1. Delegated add-to-cart. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-flp-atc]');
    if (!a) return;
    var btn = mainAtcButton();
    if (!btn || btn.disabled) return; // sold out or no form: follow the link
    e.preventDefault();
    btn.click();
    if (window.__flpVideoEngaged) emit('post_video_add_to_cart', { video: window.__flpVideoEngaged });
  });

  /* 2. Price mirror. */
  function mirrorPrice() {
    var src = document.querySelector('[data-sticky-price-source] .price, [data-sticky-price-source]');
    if (!src) return;
    var text = (src.textContent || '').replace(/\s+/g, ' ').trim();
    var now = text.match(/[$€£]\s?[\d,.]+/);
    if (!now) return;
    document.querySelectorAll('[data-flp-price-mirror]').forEach(function (el) {
      el.textContent = now[0];
    });
    // The theme's sticky bar copies this too, from custom.js. Doing it here as
    // well closes the window where it still shows the undiscounted price.
    // innerHTML, not textContent: the source carries visually-hidden "Sale
    // price" / "Regular price" labels that read as literal text otherwise.
    var sticky = document.querySelector('[data-sticky-price]');
    if (sticky && src.innerHTML && sticky.innerHTML !== src.innerHTML) sticky.innerHTML = src.innerHTML;
  }
  mirrorPrice();
  var priceSrc = document.querySelector('[data-sticky-price-source]');
  if (priceSrc && 'MutationObserver' in window) {
    new MutationObserver(mirrorPrice).observe(priceSrc, { childList: true, subtree: true, characterData: true });
  }

  /* 3. The sticky bar stays down until the real button has been passed.

     The theme's controller (custom.js) shows the bar whenever the main form
     is not intersecting, which on a long page means it is already up at the
     top of the document - before the visitor has seen the button it
     duplicates. Rather than run a second controller and fight it, this only
     ever ADDS a suppression class, which the stylesheet honours. */
  (function () {
    var bar = document.getElementById('StickyATC');
    if (!bar) return;
    var ticking = false;
    function update() {
      ticking = false;
      var btn = mainAtcButton();
      if (!btn) return;
      var passed = btn.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('flp-sticky-suppressed', !passed);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  })();

  /* 3. Video tracking, and reduced motion for the loops. */
  document.querySelectorAll('video[data-flp-autoplay]').forEach(function (v) {
    if (reduceMotion) {
      v.removeAttribute('autoplay');
      v.pause();
      v.setAttribute('controls', '');
    }
  });

  document.querySelectorAll('video[data-flp-track]').forEach(function (v) {
    var name = v.getAttribute('data-flp-track') || 'video';
    var marks = { 25: false, 50: false, 75: false, 100: false };
    var started = false;
    v.addEventListener('play', function () {
      if (started) return;
      started = true;
      window.__flpVideoEngaged = name;
      emit('start', { video: name });
    });
    v.addEventListener('timeupdate', function () {
      if (!v.duration) return;
      var pct = (v.currentTime / v.duration) * 100;
      [25, 50, 75].forEach(function (m) {
        if (!marks[m] && pct >= m) {
          marks[m] = true;
          emit('progress', { video: name, percent: m });
        }
      });
    });
    v.addEventListener('ended', function () {
      if (marks[100]) return;
      marks[100] = true;
      emit('complete', { video: name, percent: 100 });
    });
  });
})();

/* Science tabs (funnls-pdp-science). Real tablist semantics: click or
   arrow keys move the selection, Home/End jump, only the active tab is in
   the tab order. Without this script every panel is simply visible. */
(function () {
  if (window.__flpTabsInit) return;
  window.__flpTabsInit = true;

  function wire(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key, j = i;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + n) % n;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = n - 1;
        else return;
        e.preventDefault();
        select(j, true);
      });
    });
  }

  function init() { document.querySelectorAll('[data-flp-tabs]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-flp-tabs]').forEach(wire);
  });
})();

/* Buy box, stress-reset version (2026-09-10).
   1. The "Chosen by the experts" badge is rendered in the details column
      (blocks/funnls-badges.liquid) and moved over the photograph here.
   2. Single or set (blocks/funnls-buy-options.liquid): the selected card
      rewrites the offer-price block, so the sticky bar mirrors it; when the
      set is selected the form submit is intercepted and both variants are
      added through /cart/add.js, which the cart drawer picks up like any
      other add. If the drawer has not opened after a moment, fall through
      to the cart page so the shopper is never left staring at nothing. */
(function () {
  if (window.__flpBuyBoxInit) return;
  window.__flpBuyBoxInit = true;

  function placeBadge() {
    var badge = document.querySelector('[data-flp-gallery-badge]');
    if (!badge || badge.classList.contains('is-placed')) return;
    var gallery = document.querySelector('media-gallery, [data-block-id*="media-gallery"], .product-media-gallery, .product-information__media, .product-media-container');
    if (!gallery) return;
    var host = gallery.closest('[data-block-id*="media-gallery"]') || gallery;
    var cs = window.getComputedStyle(host);
    if (cs.position === 'static') host.style.position = 'relative';
    host.appendChild(badge);
    badge.classList.add('is-placed');
  }

  function money(cents, symbol) {
    var n = (cents / 100).toFixed(2);
    return symbol + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function options() {
    var root = document.querySelector('[data-flp-options]');
    if (!root) return;
    var priceSrc = document.querySelector('[data-sticky-price-source]');
    var saveEl = priceSrc && priceSrc.parentElement ? priceSrc.parentElement.querySelector('.funnls-offer-price__save') : null;
    var singleHTML = priceSrc ? priceSrc.innerHTML : '';
    var singleSave = saveEl ? saveEl.textContent : '';
    var singleSaveHidden = saveEl ? saveEl.hidden : true;
    var sym = root.getAttribute('data-currency') || '$';

    function selected() {
      var r = root.querySelector('input[name="funnls-option"]:checked');
      return r ? r.value : 'single';
    }
    function render() {
      var v = selected();
      root.querySelectorAll('.funnls-option').forEach(function (l) {
        var i = l.querySelector('input');
        l.classList.toggle('is-selected', !!i && i.value === v);
      });
      root.querySelectorAll('[data-flp-set-only]').forEach(function (el) { el.hidden = v !== 'set' || el.hasAttribute('data-ig-no-save'); });
      if (!priceSrc) return;
      // Once the Aura price test has redrawn the prices (funnls-ig-aura.js),
      // the single price is rebuilt from data-single-* like the set's, instead
      // of restoring the HTML captured at load, which holds the untested price.
      var tested = root.hasAttribute('data-ig-applied');
      if (v === 'set' || tested) {
        var key = v === 'set' ? 'set' : 'single';
        var now = +root.getAttribute('data-' + key + '-price'), was = +root.getAttribute('data-' + key + '-was');
        priceSrc.innerHTML =
          (was > now ? '<span class="visually-hidden">Sale price</span>' : '') +
          '<span class="price funnls-offer-price__now">' + money(now, sym) + '</span>' +
          (was > now ? '<span class="visually-hidden">Regular price</span><s class="compare-at-price funnls-offer-price__was">' + money(was, sym) + '</s>' : '');
        if (saveEl) {
          saveEl.textContent = was > now ? 'Save ' + money(was - now, sym) + ' (' + Math.round(((was - now) * 100) / was) + '%)' : '';
          saveEl.hidden = !(was > now);
        }
      } else {
        priceSrc.innerHTML = singleHTML;
        if (saveEl) {
          saveEl.textContent = singleSave;
          saveEl.hidden = !singleSave.trim() || singleSaveHidden;
        }
      }
    }
    root.addEventListener('change', render);
    document.addEventListener('funnls:prices', render);
    render();

    // Horizon's product-form-component adds to the cart from the button
    // click and never dispatches a native submit, so the hook is the click,
    // captured at the document before the component sees it. The sticky
    // bar's button forwards a click to this one, so it is covered too.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      if (selected() !== 'set') return;
      var partner = root.getAttribute('data-partner-variant');
      // A set sold as its own product (A Moment Set) is one line; otherwise
      // Aura + the partner go in as two.
      var setVariant = root.getAttribute('data-set-variant');
      if (!partner && !setVariant) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var idField = form.querySelector('[name="id"]');
      var id = idField ? idField.value : null;
      if (!id) { window.location.href = root.getAttribute('data-permalink'); return; }
      var btn = form.querySelector('button[type="submit"], button[name="add"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: setVariant ? [{ id: +setVariant, quantity: 1 }] : [{ id: +id, quantity: 1 }, { id: +partner, quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          try {
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, sourceId: form.id, data: { source: 'product-form-component', itemCount: cart.item_count } } }));
          } catch (err) {}
          if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
          setTimeout(function () {
            if (!document.body.classList.contains('upcartPopupShow')) window.location.href = '/cart';
          }, 1400);
        })
        .catch(function () { window.location.href = root.getAttribute('data-permalink'); });
    }, true);
  }

  function init() { placeBadge(); options(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { placeBadge(); });
})();

/* The closing single-or-set pair (sections/funnls-pdp-offer.liquid) hands
   off to the buy box: pick the matching card there, then press the real
   add-to-cart, so one path adds to the cart on this page. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-flp-offer]');
    if (!a) return;
    var which = a.getAttribute('data-flp-offer');
    var radio = document.querySelector('input[name="funnls-option"][value="' + which + '"]');
    var btn = document.querySelector('product-form-component form button[type="submit"], form[action*="/cart/add"] button[name="add"]');
    if (!radio || !btn || btn.disabled) return;    // no buy box: follow the link
    e.preventDefault();
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    btn.click();
  });
})();
